import { useTrackedProjectsInCluster } from "in_queue/contexts/ProjectDataContext";
import { ProjectType, TrackedProject } from "in_queue/types/projectType";
import { useEffect, useState } from "react";
import { Loading } from "types/loadingType";

export const getParentProjectId = ({
    parentProject,
    projectType
}: {
    parentProject: TrackedProject | undefined;
    projectType: ProjectType;
}) => {
    if (
        parentProject?.type === ProjectType.QUEUE_PROJECT &&
        projectType === ProjectType.QUEUE_PROJECT
    ) {
        // For queue projects, we use the projectId as the parentProjectId
        return parentProject.projectId;
    } else if (
        parentProject?.type === ProjectType.SPECULATIVE_PROJECT &&
        projectType === ProjectType.SPECULATIVE_PROJECT
    ) {
        // For speculative projects, we use the id (uuid) as the parentProjectId
        return parentProject.id;
    } else {
        return undefined;
    }
};

export const getParentProject = ({
    trackedProjectsInCluster,
    parentProjectId
}: {
    trackedProjectsInCluster: Loading<TrackedProject[]>;
    parentProjectId: string | undefined;
}) =>
    trackedProjectsInCluster !== "loading"
        ? trackedProjectsInCluster.find((p) => p.projectId === parentProjectId)
        : undefined;

export const useParentProject = ({
    parentProjectId
}: {
    parentProjectId: string | undefined;
}): [
    TrackedProject | undefined,
    React.Dispatch<React.SetStateAction<TrackedProject | undefined>>
] => {
    const [parentProject, setParentProject] = useState<
        TrackedProject | undefined
    >(undefined);
    const trackedProjects = useTrackedProjectsInCluster();

    useEffect(() => {
        if (trackedProjects !== "loading") {
            setParentProject(
                getParentProject({
                    trackedProjectsInCluster: trackedProjects,
                    parentProjectId
                })
            );
        }
    }, [parentProjectId, trackedProjects]);

    return [parentProject, setParentProject];
};
